import React from 'react';
import { Modal, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

import useNotification from './notification';

const { Dragger } = Upload;

export default function UploadFileDialog({ visible, onSuccess, onCancel, onError }) {
  const { sendNotification } = useNotification();

  const handleChange = (info) => {
    const { status } = info.file;
    if (status !== 'uploading') {
      // console.log(info.file, info.fileList);
    }
    if (status === 'done') {
      // message.success(`${info.file.name} file uploaded successfully.`);
      onSuccess(info.file);
    } else if (status === 'error') {
      // message.error(`${info.file.name} file upload failed.`);
      onError(info);
    }
  };

  const imageFileGuard = (file) => {
    const isImage = file.type === 'image/png' || file.type === 'image/jpeg';

    // check whether file is an image
    if (!isImage) {
      sendNotification({ msg: `${file.name} is not an image file type (.jpg, .png)`, variant: 'error' });
    }

    // check whether file is bigger than 4MB
    const isLt4M = file.size / 1024 / 1024 < 4;
    if (!isLt4M) {
      sendNotification({ msg: 'Image must be smaller than 4MB!', variant: 'error' });
    }

    return (isImage && isLt4M) || Upload.LIST_IGNORE;
  };

  return (
    <Modal visible={visible} title='Upload Image' footer={null} onCancel={onCancel}>
      <Dragger
        name='image'
        showUploadList={false}
        multiple={false}
        beforeUpload={imageFileGuard}
        onChange={handleChange}
        action={`${process.env.REACT_APP_API}/blogs/uploadpic`}>
        <p className='ant-upload-drag-icon'>
          <InboxOutlined />
        </p>
        <p className='ant-upload-text'>Click or drag file to this area to upload</p>
        {/* <p className='ant-upload-hint'>
          Support for a single or bulk upload. Strictly prohibit from uploading company data or other band files
        </p> */}
      </Dragger>
    </Modal>
  );
}
